import { SortingType } from '@/study-search/enums';

class SortingParser {
	public getSortingFromUrl(querySorting: string | undefined): SortingType {
		let sorting = SortingType.RELEVANCE;

		if (querySorting !== undefined) {
			const querySortingValue: SortingType = querySorting as SortingType;

			if (Object.values(SortingType).includes(querySortingValue)) {
				sorting = querySorting as SortingType;
			}
		}

		return sorting;
	}
}

export default new SortingParser();
